/*@ngInject*/
const UIDatetimeFormatterDirective = function ($timeout, dateUtil, formComponentUtil) {

        var linkFunction = function ($scope, $elm, $attrs, ngModelController) {

            let isEnabled,
                element = $($elm),
                timeoutList = [],
                viewValue;

            function run() {

                function handleBlur() {
                    viewValue = formComponentUtil.dateFromInput(ngModelController.$viewValue, false);
                    // only attempt to apply a date format if specified input is in a valid date format to begin with
                    if (!_.isNil(viewValue)) {
                        ngModelController.$viewValue = formComponentUtil.formatDateWithDefaultPreferences(viewValue, false);
                    }
                    ngModelController.$render();
                }

                $scope.$watch($attrs.ngModel, function (newValue) {
                    if (!element.is(':focus') && newValue) {
                        handleBlur();
                    }
                });

                element.on('blur', handleBlur);
                $scope.$on('$destroy', function () {
                    element.off('blur', handleBlur);

                    _.each(timeoutList, function (item) {
                        $timeout.cancel(item);
                    });
                });

                $scope.$watch($attrs.ngModel, function (newValue) {
                    if (!element.is(':focus') && newValue) {
                        handleBlur();
                    }
                });
            }

            timeoutList.push($timeout(function () {
                isEnabled = $elm.hasClass('ui-datetime-formatter');
                if (isEnabled) {
                    run();
                }
            }, 300));


        };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiDatetimeFormatter', UIDatetimeFormatterDirective);
